module.exports = __webpack_public_path__ + "static/media/blog5_4.df9bb206.webp";